import { Box, Checkbox, Dialog, IconButton, Menu, MenuItem, MenuList } from '@mui/material';
import { useWhapiTags } from 'context';
import { ChevronDown, CircleEllipsis, Minus, Trash } from 'lucide-react';
import React, { useEffect } from 'react';
import { TagMemberType } from 'type/type';
import { useWhapi } from '../context/WhapiContext';
import ManageTag from './ManageTag/ManageTag';

interface Props {
  handleSelectTag: (tag: string) => void;
}
interface excludedListType {
  expand: boolean;
  name: string;
  members: TagMemberType[];
}

const ListTags = ({ handleSelectTag }: Props) => {
  const { excludedGroups, advanceGroups, setAdvanceGroups, selectedTags, setSelectedTags, setSelectedGroups } = useWhapi();
  const whapiTags = useWhapiTags() ?? ['tag1', 'tag2', 'tag3', 'tag4', 'tag5', 'tag6', 'tag7', 'tag8', 'tag9', 'tag10'];
  const [excludedList, setExcludedList] = React.useState<excludedListType[]>([]);
  const [advanceList, setAdvanceList] = React.useState<excludedListType[]>([]);
  const [openTagManagement, setOpenTagManagement] = React.useState<{
    open: boolean;
    tag: string | null;
  }>({
    open: false,
    tag: null,
  });
  useEffect(() => {
    setExcludedList(
      excludedGroups.map(item => ({
        ...item,
        expand: false,
      })),
    );
  }, [excludedGroups]);
  useEffect(() => {
    setAdvanceList(
      advanceGroups.map(item => ({
        ...item,
        expand: false,
      })),
    );
  }, [advanceGroups]);
  return (
    whapiTags && (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', overflowX: 'hidden', overflowY: 'scroll', height: '100%', flexGrow: 1 }}>
        <Dialog
          open={openTagManagement.open}
          onClose={() =>
            setOpenTagManagement({
              open: false,
              tag: null,
            })
          }
        >
          {openTagManagement.tag ? <ManageTag tagLabel={openTagManagement.tag} /> : null}
        </Dialog>

        {selectedTags.includes(openTagManagement.tag as string) && (
          <MenuItem
            onClick={() => {
              setSelectedTags(prev => prev.filter(tag => tag !== openTagManagement.tag));
            }}
          >
            Remove Tag <Trash size={16} style={{ marginLeft: '10px' }} />
          </MenuItem>
        )}

        {whapiTags.map((tag, index) => (
          <Box key={index} sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
            <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
              <Checkbox size='small' checked={selectedTags.includes(tag)} onChange={() => handleSelectTag(tag)} />
              <p className='text-overflow' style={{ width: '100%' }}>
                {tag}
              </p>
              <IconButton
                onClick={() => {
                  setOpenTagManagement({
                    open: true,
                    tag: tag,
                  });
                }}
              >
                <CircleEllipsis size={20} />
              </IconButton>
            </Box>
            {excludedList.map(
              (group, index) =>
                group.name === tag &&
                group.members.length > 0 && (
                  <MenuList
                    sx={{
                      width: '90%',
                      padding: '0 !important',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '5px',
                      margin: '0 auto',
                      boxShadow: '2px 2px 5px var(--black01)',
                      borderRadius: '5px',
                      overflow: 'hidden',
                      cursor: 'pointer',
                    }}
                    key={index}
                  >
                    <Box
                      onClick={() => setExcludedList(prev => prev.map((item, idx) => (idx === index ? { ...item, expand: !item.expand } : item)))}
                      sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'var(--primary02)', padding: '5px 10px' }}
                    >
                      <p style={{ fontSize: 10 }}>Excluded List ({excludedList[index].members.length})</p>
                      <ChevronDown size={16} style={{ transition: 'all 0.5s ease-in-out', transform: excludedList[index].expand ? undefined : 'rotate(180deg)' }} />
                    </Box>
                    {excludedList[index].expand &&
                      group.members.map((member, index) => (
                        <MenuItem key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', padding: '5px 10px !important', gap: '10px' }}>
                          <IconButton onClick={() => setSelectedGroups(prev => [...prev, member])}>
                            <Minus size={10} color={'red'} />
                          </IconButton>
                          {member.fn}
                        </MenuItem>
                      ))}
                  </MenuList>
                ),
            )}
            {advanceList.map(
              (group, index) =>
                group.name === tag &&
                group.members.length > 0 && (
                  <MenuList
                    sx={{
                      width: '90%',
                      padding: '0 !important',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '5px',
                      margin: '0 auto',
                      boxShadow: '2px 2px 5px var(--black01)',
                      borderRadius: '5px',
                      overflow: 'hidden',
                      cursor: 'pointer',
                    }}
                    key={index}
                  >
                    <Box
                      onClick={() => setAdvanceList(prev => prev.map((item, idx) => (idx === index ? { ...item, expand: !item.expand } : item)))}
                      sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'rgba(var(--info-code), 0.2)', padding: '5px 10px' }}
                    >
                      <p style={{ fontSize: 10 }}>Advance List ({advanceList[index].members.length})</p>
                      <ChevronDown size={16} style={{ transition: 'all 0.5s ease-in-out', transform: advanceList[index].expand ? undefined : 'rotate(180deg)' }} />
                    </Box>
                    {advanceList[index].expand &&
                      group.members.map((member, index) => (
                        <MenuItem key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', padding: '5px 10px !important', gap: '10px' }}>
                          <IconButton onClick={() => setAdvanceGroups(prev => prev.map(tagItem => (tagItem.name === tag ? { ...tagItem, members: tagItem.members.filter(memberItem => memberItem !== member) } : tagItem)))}>
                            <Minus size={10} color={'red'} />
                          </IconButton>
                          <p className='text-overflow'>{member.fn}</p>
                        </MenuItem>
                      ))}
                  </MenuList>
                ),
            )}
          </Box>
        ))}
      </Box>
    )
  );
};

export default ListTags;
